(function () {
  window.exclusiveCardService = {
    get() {
      return axios.get(`/api/exclusive-card/get.php`);
    },
    getActive() {
      return axios.get('/api/exclusive-card/active.php');
    },
    save(data) {
      return axios.post('/api/exclusive-card/save.php', data);
    },
    toggleActive(data) {
      return axios.post('/api/exclusive-card/active.php', data);
    },
    redeem(data) {
      return axios.post('/api/exclusive-card/redeem.php', data);
    },
    giveaway(data) {
      return axios.post('/api/exclusive-card/giveaway.php', data);
    },
    getUserCards(twitchId) {
      return axios.get(`/api/exclusive-card/user-cards.php?twitchId=${twitchId}`);
    }
  };
})();
